import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "./AboutPage.css";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import GroupsIcon from "@mui/icons-material/Groups";
import HandshakeIcon from "@mui/icons-material/Handshake";
// Import partner logos
import ezerMitzionLogo from "../assets/ezer_mitzion.png";
import yadEliezerLogo from "../assets/yad eliezer.png";
import tzahalLogo from "../assets/tzahal.png";
import fullstackLogo from "../assets/fullstack.png";

const AboutPage: React.FC = () => {
  const { t, language } = useLanguage();

  // Team members data structure in both languages
  const teamSections = {
    he: [
      {
        title: "חברות העמותה",
        members: [
          "לורן אינגר",
          "סטפני גליק",
          "עדנה ליימן",
          "טובי מילר",
          "אמונה רוזנפלדר",
          "חנה רוזנפלדר",
          "בתיה קראוס",
        ],
      },
      {
        title: "הוועד המנהל",
        members: ["לורן אינגר", "סטפני גליק"],
      },
      {
        title: "מנהלת כללית",
        members: ["רובין טרייסטמן"],
      },
      {
        title: "אתר אינטרנט ודיגיטל",
        members: ["אליאורה בלוך"],
      },
      {
        title: "ייעוץ והכוונה",
        members: ["רמי טרייסטמן, פולסטאק מערכות"],
      },
    ],
    en: [
      {
        title: "Association Members",
        members: [
          "Stephanie Glick",
          "Lauren Inger",
          "Batya Krauss",
          "Edna Leiman",
          "Tobi Miller",
          "Chani Rosenfelder",
          "Faith Rosenfelder",
        ],
      },
      {
        title: "Board",
        members: ["Stephanie Glick", "Lauren Inger"],
      },
      {
        title: "Director",
        members: ["Robin Treistman"],
      },
      {
        title: "Website and digital services",
        members: ["Eliora Bloch"],
      },
      {
        title: "Advisor",
        members: ["Rami Treistman, FullStack Systems Ltd."],
      },
    ],
  };

  // Get the current language team data
  const currentTeamData =
    teamSections[language as keyof typeof teamSections] || teamSections.he;

  return (
    <div className="about-page">
      <h1 className="about-page-title">{t("about.us")}</h1>

      <div className="about-content">
        <div className="mission-section">
          <div className="section-icon">
            <VolunteerActivismIcon />
          </div>
          <h2>{t("about.mission.title")}</h2>
          <p>{t("about.mission.text")}</p>
        </div>

        <div className="team-section">
          <div className="section-icon">
            <GroupsIcon />
          </div>
          <h2>{t("about.team.title")}</h2>
          <p>{t("about.team.text")}</p>

          <div className="team-simple-container">
            {currentTeamData.map((section, sectionIndex) => (
              <div key={sectionIndex} className="team-category-simple">
                <h3 className="team-category-title">{section.title}</h3>
                <div className="team-members-simple">
                  {section.members.join(", ")}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="partners-section">
          <div className="section-icon">
            <HandshakeIcon />
          </div>
          <h2>{t("about.partners.title")}</h2>
          <p>{t("about.partners.text")}</p>
          <div className="partners-grid">
            <div className="partner-logo">
              <div className="partner-logo-container">
                <a
                  href="https://www.ami.org.il/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={ezerMitzionLogo}
                    alt="Ezer Mitzion"
                    className="ezer-mitzion-logo"
                  />
                </a>
              </div>
            </div>
            <div className="partner-logo">
              <div className="partner-logo-container">
                <a
                  href="https://yadeliezer.org.il/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={yadEliezerLogo} alt="Yad Eliezer" />
                </a>
              </div>
            </div>
            <div className="partner-logo">
              <div className="partner-logo-container">
                <a
                  href="https://netzahyehuda.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={tzahalLogo} alt="Tzahal" />
                </a>
              </div>
            </div>
            <div className="partner-logo">
              <div className="partner-logo-container">
                <a
                  href="https://www.fullstack.co.il/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={fullstackLogo} alt="Fullstack" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
